import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PlaningArea, PlaningDate} from '../../../../../../projects/api/src/template/template.model';
import {
  BORDER_24H_IN_MINUTES,
  BORDER_48H_IN_MINUTES,
  LEFT_BORDER_6H_IN_MINUTES,
  RANGE_MAX_MINUTES_IN_24H,
  RANGE_MIN_MINUTES_IN_24H,
  RIGHT_BORDER_18H_IN_MINUTES
} from './planing-area-block.constants';
import {NEW_PLANING_DATE_ID} from '../planing-date-block/planing-date-block.const';


@Component({
  selector: 'app-planing-area-block',
  templateUrl: './planing-area-block.component.html',
  styleUrls: ['./planing-area-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaningAreaBlockComponent implements OnInit {
  @Input() planingAreaData: PlaningArea;
  @Input() idx: number;
  @Input() disabled = false;
  @Output() removePlaningArea = new EventEmitter<any>();
  @Output() allowScroll = new EventEmitter();
  public rangeLimitValues: [number, number] = [LEFT_BORDER_6H_IN_MINUTES, RIGHT_BORDER_18H_IN_MINUTES];
  public rangeValues: number[] = [LEFT_BORDER_6H_IN_MINUTES, RIGHT_BORDER_18H_IN_MINUTES];
  public rangeLocalTimeValues: number[] = [1, RANGE_MAX_MINUTES_IN_24H];
  public minValue = RANGE_MIN_MINUTES_IN_24H;
  public maxValue = RANGE_MAX_MINUTES_IN_24H;
  public showSubrange = [];
  public valueLimits = {
    NOT_WORKING_TIME: {
      min: RANGE_MIN_MINUTES_IN_24H, max: RANGE_MAX_MINUTES_IN_24H * 3,
      rangeLimitValues: [BORDER_24H_IN_MINUTES, BORDER_48H_IN_MINUTES],
      rangeValues: [BORDER_24H_IN_MINUTES, BORDER_48H_IN_MINUTES]
    },
  };
  public limitLabels = {
    WORKING_TIME: ['on.', 'off.'], // По рабочему времени
    DAILY: ['00:00', '24:00'], // По местному времени
    NOT_WORKING_TIME: ['off.', 'on.'], // По нерабочему времени
    DAY_TIME: ['sunrise', 'sunset'], // По астрономическому дню
    NIGHT_TIME: ['sunset', 'sunrise'], // По астрономической ночи
    YEAR_DAY: ['00:00', '24:00'], // По местному времени, по конкретным датам
  };
  public tempPlaningDate: PlaningDate;

  readonly NEW_PLANING_DATE_ID = NEW_PLANING_DATE_ID;

  constructor() {
  }

  ngOnInit() {
    this.showSubrange = this.planingAreaData.timeranges.map(timerange => timerange.activesubrange !== 0 || timerange.passivesubrange !== 0);
    this.createTempPlaningDate();
  }

  /**
   * Обновляет границы timerange
   * @param bounds
   * @param timeRangeIndex
   */
  public updateBounds(bounds, timeRangeIndex = 0) {
    this.planingAreaData.timeranges[timeRangeIndex].leftbound = bounds[0];
    this.planingAreaData.timeranges[timeRangeIndex].rightbound = bounds[1];
  }

  createTempPlaningDate() {
    this.tempPlaningDate = {
      datefrom: undefined,
      dateto: undefined,
      yearly: false
    };
  }

  addPlaningDate(data) {
    this.planingAreaData.planningdates.push(this.tempPlaningDate);
    this.createTempPlaningDate();
  }

  removePlaningDate(idx) {
    this.planingAreaData.planningdates = this.planingAreaData.planningdates.filter( (_v, _index) => _index !== idx);
  }


  public addRange() {
    this.planingAreaData.timeranges.push(
      {
        leftbound: 0,
        rightbound: 180,
        bindingtype: 'BOTH_BORDERS',
        activesubrange: 0,
        passivesubrange: 0
      }
    );

  }
}
